import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Col, Row } from 'antd';
import irgtLogo from '../../images/logo-CS-horizontal_white-TM.png'
import careerSwipeProcessFr from '../../images/careerSwipeProcessPage/img-process-fr.png';
import careerSwipeProcessEn from '../../images/careerSwipeProcessPage/img-process-en.png';
import './index.css'
import BackgroundImage from '../../common/BackgroundImage';
import ArrowLeftButton from '../../common/ArrowLeftButton';
import ArrowRightButton from '../../common/ArrowRightButton';
import { DICTIONARY } from '../../utilities/dictionary';
import { registerLogEvent } from '../../firebase/endpoints';
import { EventsName } from '../../models/events.models';

// Component
const CareerSwipeProccessPage = () => {

    // Hooks React
    const location = useLocation();
    const navigate = useNavigate();

    // Handlers
    const previousPage = () => {
        if (location.pathname === '/en/process') {
            navigate("/en/introduction");
        } else if (location.pathname === '/fr/process') {
            navigate("/fr/introduction");
        }
    }

    const nextPage = () => {
        if (location.pathname === '/en/process') {
            navigate("/en/profiles/1");
        } else if (location.pathname === '/fr/process') {
            navigate("/fr/profiles/1");
        }
    }

    // Effects
    useEffect(() => {
        registerLogEvent('view_item', { view_name: EventsName.PROCCESSPAGE, language: location.pathname === '/en/proccess' ? 'English' : 'French' })
        const startTime = Date.now();
        if (location.pathname === '/en/process') {
            registerLogEvent('navigate', { view_name: EventsName.PROCCESSPAGE, language: 'English' })

        } else if (location.pathname === '/fr/process') {
            registerLogEvent('navigate', { view_name: EventsName.PROCCESSPAGE, language: 'French' })
        }

        return () => {
            const duration = Date.now() - startTime;

            if (location.pathname === '/en/process') {
                registerLogEvent('view_duration', { view_name: EventsName.PROCCESSPAGE, duration, language: 'English' })

            } else if (location.pathname === '/fr/process') {
                registerLogEvent('view_duration', { view_name: EventsName.PROCCESSPAGE, duration, language: 'French' })
            }
        };
    }, [location.pathname]);

    return (
        <div className='container-career-swipe-page'>
            <BackgroundImage />
            <div className="card-container">
                <Row className='subcontainer-career-swipe-page'>
                    <Col span={24} className='header-career-swipe-page'>
                        <span className='header-title-text'>
                            {DICTIONARY['career_swipe_process_title'][location.pathname.split('/')[1] === 'en' ? 'English' : 'French']}
                        </span>
                        <img alt="IRGT Logo" src={irgtLogo} className='header-img-logo-irgt' />
                    </Col>
                    <Col span={24} className='container-img-career-swipe-page'>
                        <img
                            src={
                                location.pathname.split('/')[1] === 'en'
                                    ? careerSwipeProcessEn
                                    : careerSwipeProcessFr
                            }
                            className='img-process'
                            alt="Descripción de la imagen" />
                    </Col>
                </Row>
            </div>
            <ArrowLeftButton onClickFunction={previousPage} />

            <ArrowRightButton onClickFunction={nextPage} />
        </div >
    )
}

export default CareerSwipeProccessPage
